/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

// and Menu.js

import * as React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import Auth from "../shared/Auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NavLink, Link } from "react-router-dom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import './_Sidebar.css';
import GestureDetect from "./GestureDetect";
import Icon from "./Icon";
import AlertIcon from "./AlertIcon";
import ChatIcon from "./chat/ChatIcon";
import BaseCom from "./BaseCom";
import L from "./Lang";

class NavItem extends React.Component {

    render() {
        return (<li className="nav-item">
            <NavLink to={this.props.href} className="nav-link d-flex align-items-center" end={this.props.end}>
                {this.props.icon ? (<FontAwesomeIcon icon={this.props.icon} className="me-1 d-block" />) : ''}
                <div>{this.props.label}</div>
                {this.props.new ? <div className="badge bg-warning ms-1">NEW</div> : ''}
            </NavLink>
        </li>);

    }
}

class NavHeader extends React.Component {

    render() {
        return (<div className="nav-header text-uppercase p-1 m-1 mb-1 pb-1">{this.props.label}</div>);
    }
}

class NavGroup extends React.Component {
    render() {
        return (<ul className="nav nav-pills flex-column">
            {this.props.children}
        </ul>);

    }
}

export const SidebarGlobal = {
    setSubNav(children) { },
    clearSubNav() { }
};

class Sidebar extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            toggle: window.innerWidth >= 768,
            subNav: null,
            search: {}
        }
        this.returnToAdmin = this.returnToAdmin.bind(this);
        this.setSubNav = this.setSubNav.bind(this);
        this.clearSubNav = this.clearSubNav.bind(this);
        this.search = this.search.bind(this);
        this.toggle = this.toggle.bind(this);
        this.getLogo = this.getLogo.bind(this);
        SidebarGlobal.setSubNav = this.setSubNav;
        SidebarGlobal.clearSubNav = this.clearSubNav;
    }

    async componentDidMount() {
        this.props.onSidebarToggle(this.state.toggle);
        await this.getMainOrg();
        await this.getSettings();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    returnToAdmin() {
        if (this.state.user.impersonatedByUser) {
            qreq.post('/api/user/impersonate/return', {}, j => {
                if (j.errorCode === 0)
                    document.location.replace('/');
            })
        }
    }

    setSubNav(children) {
        setTimeout(() => {
            this.setState({ subNav: children });
        }, 100);
    }

    clearSubNav() {
        this.setState({ subNav: null });
    }

    search(e) {
        if (e) e.preventDefault();
        if (this.state.search.query)
            this.props.navigate('/search/' + encodeURIComponent(this.state.search.query));
        else
            this.props.navigate('/');
    }

    toggle(on) {
        this.setState({ toggle: on });
        this.props.onSidebarToggle(on);
    }



    render() {
        if (!this.state.publicSettings)
            return;

        return (<>
            <GestureDetect onSwipeLeft={() => this.toggle(true)} onSwipeRight={() => this.toggle(false)} />
            <nav className="c-nav navbar --bg-primary no-select">
                <div className="container-fluid d-flex justify-content-between align-items-center c-nav-content">
                    <div className="d-block me-2">
                        <button onClick={() => this.toggle(!this.state.toggle)} className="navbar-toggler d-none d-md-block" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarToggle" aria-controls="sidebarToggle" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="icon-wrapper">
                            <img src={this.getLogo()} alt="" className={'d-block d-md-none icon bg-white rounded'} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {this.state.subNav}
                        <ChatIcon />
                        <AlertIcon />
                        <Dropdown className="ms-2" style={{ zIndex: '9992' }}>
                            <Dropdown.Toggle className="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false" variant="secondary">
                                <strong><FontAwesomeIcon icon={fa.faUser} /> <span className="d-none d-md-inline">{this.state.user ? this.state.user.firstName + ' ' + this.state.user.lastName : ''}</span></strong>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                                {this.state.user.impersonatedByUser ? <Dropdown.Item className="dropdown-item" onClick={e => { e.preventDefault(); this.returnToAdmin(); }}><L>Back to</L> {this.state.user.impersonatedByUser.firstName + ' ' + this.state.user.impersonatedByUser.lastName}</Dropdown.Item> : ''}
                                {/*<Dropdown.Item role="button" className="dropdown-item" onClick={e => { e.preventDefault(); this.props.navigate('/my'); }}><L>My Account</L></Dropdown.Item>*/}
                                <Dropdown.Item role="button" className="dropdown-item" onClick={e => { e.preventDefault(); this.props.navigate('/logout'); }}><L>Logout</L></Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </nav>
            <nav className={'c-sidebar d-md-flex flex-column flex-shrink-0 --bg-primary no-select ' + (this.state.toggle ? 'c-sidebar-open' : 'c-sidebar-close')}>
                <div className="mb-2 p-3 pt-0 pb-1">
                    <Link to="/" className="d-flex justify-content-center align-items-center mb-1 mb-md-0 me-md-auto text-white text-decoration-none p-3">
                        <img src={this.getLogo()} alt="" className={'d-block img-fluid rounded' + (this.state.user.organizationID ? ' bg-white p-2' : '')} style={{ maxWidth: '100px', boxShadow: '0 0 5px rgba(255,255,255,0.2)' }} />
                    </Link>
                </div>
                <div className="mb-auto">
                    {this.state.MODEL === 'MST' && <>
                        <NavHeader label="Orchestrator" />
                        <NavGroup>
                            {Auth.hasRole('admin') ? <NavItem href="/instance" label="Instances" icon={fa.faInstitution} /> : ''}
                        </NavGroup>
                    </>}
                    {this.state.MODEL !== 'MST' && <>
                        {(Auth.hasRole('manager') || Auth.hasRole('account-manager') || this.state.MODEL === 'WMS') && <>
                            <NavHeader label="Main" />
                            <NavGroup>
                                {Auth.hasRole('manager') || Auth.hasRole('account-manager') ? <NavItem href="/dashboard" label="Dashboard" icon={fa.faGaugeSimpleHigh} /> : ''}
                                {this.state.MODEL === 'WMS' && <NavItem href="/calendar" label="Calendar" icon={fa.faCalendar} />}
                                {this.state.MODEL === 'WMS' && <NavItem href="/myday" label="My Day" icon={fa.faSun} />}
                            </NavGroup>
                        </>}
                        {this.state.MODEL === 'WMS' && (Auth.hasRole('account-manager') || Auth.hasRole('field') || Auth.hasRole('admin')) && <>
                            <NavHeader label={this.T('subject') + 's'} />
                            <NavGroup>
                                {Auth.hasRole('manager') || Auth.hasRole('account-manager') ? <NavItem href="/lead" label="Queue" icon={fa.faNetworkWired} /> : ''}
                                {Auth.hasRole('account-manager') || Auth.hasRole('provider') || Auth.hasRole('nurse') ? <NavItem href="/order" label={this.T('subject') + 's'} icon={fa.faBox} /> : ''}
                            </NavGroup></>}
                        {this.state.MODEL === 'LIS' && <>
                            <NavHeader label="Lab" />
                            <NavGroup>
                                <NavItem href="/specimen/list" label={this.T('specimen') + 's'} icon={fa.faVial} />
                                {Auth.hasRole('manager') && <NavItem href="/results/review" label="Results" icon={fa.faVialCircleCheck} />}
                                {Auth.hasRole('admin') && <NavItem href="/lab/manager" label="Lab Management" icon={fa.faGears} />}
                            </NavGroup>
                        </>}

                        {this.state.MODEL === 'GEN' && <>
                            <NavHeader label="Work" />
                            <NavGroup>
                                {Auth.hasRole('manager') && <NavItem href="/project" label="Projects" icon={fa.faBolt} />}
                                <NavItem href="/workorder" label="Work Order" icon={fa.faBriefcase} />
                            </NavGroup>
                        </>}
                        {this.state.MODEL === 'MNF' && <>
                            {Auth.hasRole('manager') && <>
                                <NavHeader label="Manufacturing" />
                                <NavGroup>
                                    <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} end />
                                    <NavItem href="/inventory/instock" label="In Stock" icon={fa.faCubes} />
                                    <NavItem href="/product/list" label="Products" icon={fa.faBox} />
                                    <NavItem href="/scan/in" label="Scan In" icon={fa.faPlaneArrival} />
                                    <NavItem href="/scan/out" label="Scan Out" icon={fa.faPlane} />
                                </NavGroup>
                            </>}
                            {(Auth.hasRole('distribution-recipient') || Auth.hasRole('sub-distributor')
                                || Auth.hasRole('distributor') || Auth.hasRole('billing-distributor')) && <>
                                    <NavHeader label="Distribution" />
                                    <NavGroup>
                                        {!Auth.hasRole('manager') && <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} />}
                                        <NavItem href="/purchase-order" label="Purchase Orders" icon={fa.faBoxes} />
                                        {!Auth.hasRole('manager') && <NavItem href="/scan/in" label="Scan In" icon={fa.faPlaneArrival} />}
                                    </NavGroup>
                                </>}
                        </>}

                        {Auth.hasRole('distributor') && !Auth.hasRole('manager') && <>
                            <NavHeader label="Management" />
                            <NavGroup>
                                <NavItem href="/account" label="Accounts" icon={fa.faHouse} />
                            </NavGroup>
                        </>}

                        {this.state.MODEL !== 'GEN' && this.state.MODEL !== 'MNF' && Auth.hasRole('billing') && <>
                            <NavHeader label="Billing" />
                            <NavGroup>
                                <NavItem href="/claim/list" label="Claims" icon={fa.faFileInvoiceDollar} />
                            </NavGroup>
                        </>}

                        {Auth.hasRole('admin') ? <>
                            <NavHeader label="Management" />
                            <NavGroup>
                                {Auth.hasRole('account-manager') && <NavItem href="/account" label="Accounts" icon={fa.faHouse} />}
                                {Auth.hasRole('admin') ? <NavItem href="/invoice" label="Invoices" icon={fa.faFileInvoice} /> : ''}
                                {this.state.MODEL === 'GEN' && Auth.hasRole('admin') ? <NavItem href="/quote" label="Quotes" icon={fa.faDiagramPredecessor} /> : ''}
                                {Auth.hasRole('admin') ? <NavItem href="/payment-transaction" label="Payment Transactions" icon={fa.faCashRegister} /> : ''}
                                {this.state.MODEL === 'WMS' && Auth.hasRole('admin') ? <NavItem href="/reports" label="Reports" icon={fa.faFileExcel} /> : ''}
                            </NavGroup></> : ''}

                    </>}

                    {(Auth.hasRole('account-manager') || Auth.hasRole('sales') || Auth.hasRole('admin')) && <>
                        <NavHeader label="Admin" />
                        <NavGroup>
                            <NavItem href="/manager" label={'Administration'} icon={fa.faScrewdriverWrench} />
                        </NavGroup>
                    </>}

                </div>
            </nav>
            <nav className="c-nav-mobile d-flex d-md-none align-items-center justify-content-evenly  no-select">
                {(Auth.hasRole('manager') || Auth.hasRole('account-manager')) && <NavLink to="/dashboard" className="c-nav-mobile-item">
                    <Icon icon="faGaugeSimpleHigh" />
                    <span>Dashboard</span>
                </NavLink>}
                {this.state.MODEL === 'LIS' && <NavLink to="/specimen/list" className="c-nav-mobile-item">
                    <Icon icon="faVial" />
                    <span>{this.T('specimen') + 's'}</span>
                </NavLink>}
                {this.state.MODEL === 'LIS' && Auth.hasRole('manager') && <NavLink to="/results/review" className="c-nav-mobile-item">
                    <Icon icon="faVialCircleCheck" />
                    <span>Results</span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('practitioner') || Auth.hasRole('nurse')) && <NavLink to="/myday" className="c-nav-mobile-item">
                    <Icon icon="faSun" />
                    <span>My Day</span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && <NavLink to="/calendar" className="c-nav-mobile-item">
                    <Icon icon="faCalendar" />
                    <span>Calendar</span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('account-manager') || Auth.hasRole('provider') || Auth.hasRole('nurse')) && <NavLink to="/order" className="c-nav-mobile-item">
                    <Icon icon="faBox" />
                    <span>Patients</span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('manager') || Auth.hasRole('account-manager')) && <NavLink to="/lead" className="c-nav-mobile-item">
                    <Icon icon="faNetworkWired" />
                    <span>Queue</span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && <NavLink to="/inventory" className="c-nav-mobile-item">
                    <Icon icon="faWarehouse" />
                    <span>Inventory</span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && <NavLink to="/purchase-order" className="c-nav-mobile-item">
                    <Icon icon="faBoxes" />
                    <span>POs</span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && Auth.hasRole('manager') && <NavLink to="/product/list" className="c-nav-mobile-item">
                    <Icon icon="faBox" />
                    <span>Products</span>
                </NavLink>}
                <NavLink to="/menu" className="c-nav-mobile-item">
                    <Icon icon="faBars" />
                    <span>Menu</span>
                </NavLink>
            </nav>
        </>);
    }
}

export default withParamsAndNavigate(Sidebar);